import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import WelcomeName from "./WelcomeName";
import SignInSignOutButton from "./SignInSignOutButton";
import { useLocation, Link as RouterLink } from "react-router-dom";

const NavBar = () => {
    const loc = useLocation();

    return (
        <AppBar position="static">
            <Toolbar>
              <Tabs
                textColor="inherit"
                indicatorColor="secondary"
                value={loc.pathname}
                sx={{ flexGrow: 1 }}
              >
                <Tab value="/" label="Home" component={RouterLink} to = "/"/>
                <Tab value="/profile" label="My Info" component={RouterLink} to = "/profile"/>
                <Tab value="/directory" label="Directory" component={RouterLink} to = "/directory"/>
                <Tab value="/orgchart" label="Orgchart" component={RouterLink} to = "/orgchart"/>
              </Tabs>
              <WelcomeName />
              <SignInSignOutButton />
            </Toolbar>
        </AppBar>
    );
};

export default NavBar;
